<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-box">
          <div class="row">
            <div class="col-md-12">
              <h4 class="header-title m-b-20">Liste des fiches</h4>
            </div>
            <div class="col-md-12">
              <customer-search-form
                :values="form"
                :watchValues=true
                @loading="handleLoading"
                @loaded="handleLoaded"
              ></customer-search-form>
            </div>
            <div class="col-md-12" v-loading="loading">
              <customers-table
                :customers="models.customers"
                :pagination="models.pagination"
                @changePage="handleCurrentPage"
              ></customers-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomerSearchForm from '@db2b/keystone/components/Entities/Forms/CustomerSearchForm.vue'
  import CustomersTable from '@db2b/keystone/components/Entities/Tables/CustomersTable.vue'

  export default {
    name: 'clients',
    components: {
      CustomersTable,
      CustomerSearchForm
    },
    data () {
      return {
        models: {
          customers: [],
          pagination: {}
        },
        form: {
          parent_id: null,
          current_page: 0
        },
        loading: false
      }
    },
    sync: {
      models: {
        customers: 'customer'
      }
    },
    methods: {
      handleLoading () {
        this.loading = true
      },
      handleLoaded ({form, customers, pagination}) {
        this.loading = false
        this.models.customers = customers
        this.models.pagination = pagination
      },
      handleCurrentPage ({page}) {
        console.log(page)
        this.form = {
          parent_id: this.form.parent_id,
          current_page: page
        }
      }
    },
    activated () {
      this.$store.commit('app/ui/changeTitle', 'Clients et Prospects')
      this.$store.commit('app/ui/changeSubtitle', 'Gestion du parc client et prospection commerciale.')
    }
  }
</script>



// WEBPACK FOOTER //
// CustomersList.vue?d8f15656